import React from 'react';
import PropTypes from 'prop-types';

const RANK_IMAGES = {
    1: '/img/trophies/gold.png',
    2: '/img/trophies/silver.png',
    3: '/img/trophies/bronze.png',
};

const formatDate = (dateStr) => {
    const raw = dateStr.includes('T') ? dateStr : dateStr + 'T12:00:00Z';
    const d = new Date(raw);
    if (isNaN(d)) return dateStr;
    return `${d.getUTCMonth() + 1}/${d.getUTCDate()}/${String(d.getUTCFullYear()).slice(2)}`;
};

const RANK_LABELS = { 1: 'First Place', 2: 'Second Place', 3: 'Third Place' };

const PLAYOFF_TIER_LABELS = { gold: 'Champion', silver: 'Silver', bronze: 'Bronze' };
const PLAYOFF_TIER_CSS = { gold: 'playoff-trophy-gold', silver: 'playoff-trophy-silver', bronze: 'playoff-trophy-bronze' };

const getTrophyProps = (trophy) => {
    if (trophy.type === 'playoff') {
        const tier = String(trophy.tier ?? 'gold').toLowerCase();
        const tierLabel = PLAYOFF_TIER_LABELS[tier] || 'Champion';
        const lines = [`Postseason Push ${tierLabel}`];
        if (trophy.date) lines.push(formatDate(trophy.date));
        return {
            src: '/img/trophies/playoff_win.png',
            alt: `Postseason Push ${tierLabel}`,
            tooltipLines: lines,
            leagueClass: PLAYOFF_TIER_CSS[tier] || '',
        };
    }
    const league = trophy.Tournament?.league;
    const leagueName = trophy.Tournament?.name?.split(' — ')[0] ?? 'Daily Championship';
    const date = trophy.Tournament?.date ?? trophy.date;
    return {
        src: RANK_IMAGES[trophy.finalRank] || '/img/trophies/gold.png',
        alt: `${leagueName} ${RANK_LABELS[trophy.finalRank] || ''}`,
        tooltipLines: [leagueName, date ? formatDate(date) : null, RANK_LABELS[trophy.finalRank] || `#${trophy.finalRank}`].filter(Boolean),
        leagueClass: `trophy-league-${league ?? 'none'}`,
    };
};

const TrophyCase = ({ trophies }) => {
    if (!trophies?.length) {
        return <span className="trophy-case-empty">No trophies yet.</span>;
    }

    return (
        <div className="trophy-case">
            {trophies.map((trophy, i) => {
                const { src, alt, tooltipLines, leagueClass } = getTrophyProps(trophy);
                return (
                    <span
                        key={trophy.playoffRunID || trophy.Tournament?.tournamentID || i}
                        className={`trophy-item tooltip-container ${leagueClass}`}
                    >
                        <img src={src} alt={alt} className="trophy-img" />
                        <span className="tooltip">{tooltipLines.map((line, j) => (
                            <React.Fragment key={j}>{j > 0 && <br />}{line}</React.Fragment>
                        ))}</span>
                    </span>
                );
            })}
        </div>
    );
};

TrophyCase.propTypes = {
    trophies: PropTypes.arrayOf(PropTypes.shape({
        type: PropTypes.string,
        finalRank: PropTypes.number,
        playoffRunID: PropTypes.any,
        Tournament: PropTypes.shape({
            tournamentID: PropTypes.any,
            name: PropTypes.string,
            league: PropTypes.number,
        }),
    })).isRequired,
};

export default TrophyCase;
